// extracted by mini-css-extract-plugin
export default {"video":"video_video__ClhIj","videoFull":"video_videoFull__Wxid6","videoWrapper":"video_videoWrapper__T9Dpd","videoAction":"video_videoAction__iQjfa"};